<template>
    <div class="add-condition-modal-wrapper">
        <TitleBaseBox :title="data.title" :noButton="true" @close="close" class="add-condition-box">
            <el-form :rules="rules" :model="formModal" ref="ruleForm" label-width="100px">
                <el-form-item label="条件名称" prop="nodeName" class="add-condition-form-item">
                    <el-input class="condition-title" v-model="formModal.nodeName" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="条件逻辑" prop="groups">
                    <div class="condition-logic-right">
                        <div class="condition-logic-tip-title">
                            <span class=""><span class="key-note">IF&nbsp;</span>满足以下条件时</span>
                            <span class="use-guide"><i class="el-icon-s-management" />使用指南</span>
                        </div>
                        <div class="add-condition-group-wrapper">
                            <!-- 条件组 -->
                            <div
                                class="condition-group-content"
                                v-for="(group, jIndex) in formModal.groups"
                                :key="jIndex"
                                v-show="group.updateState !== 'delete'"
                            >
                                <div class="group-name">
                                    <span class="condition-index">{{ getIndex(jIndex) }}</span>
                                    <TextInput
                                        class="group-name-input"
                                        v-model="group.groupName"
                                        :widget="groupNameWidget"
                                        :rules="groupNameRules"
                                        :validation="myValidation"
                                        @change="groupNameChange(jIndex, $event)"
                                    />
                                </div>
                                <!-- 指标组 -->
                                <ConditionGroup
                                    v-model="group.conditions"
                                    @change="groupChange(jIndex, $event)"
                                    :widget="condWidgetConfig"
                                    :validation="myValidation"
                                    class="group-conditon"
                                />
                                <span class="op">
                                    <i class="delete" @click="deleteCondition(jIndex)"></i>
                                </span>
                            </div>
                            <div class="condition-group-btn">
                                <span class="plus-btn" @click="addConditionGroup"><i class="el-icon-plus"/></span>
                                <span class="supplement-cond"
                                    >{{ formModal.groups.length == 0 ? "添加条件组" : "添加并列条件组" }}
                                    <span class="condition-index">{{ getIndex(formModal.groups.length) }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="not-match-wrap">
                            <span><span class="key-note">No match&nbsp;</span>不满足以上条件时</span>
                            <div class="match-switch">
                                <el-switch v-model="formModal.isSupply" />
                                <span class="supplement-cond">开启补充条件</span>
                            </div>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div class="add-condition-bottom">
                <RoundButton :text="cancelLabel" cls="cancel-btn" @btnClick="cancelClick" />
                <RoundButton :text="confirmLabel" :class="{ 'disabled-btn': !canSubmit }" :disabled="!canSubmit" @btnClick="confirmClick" />
            </div>
        </TitleBaseBox>
    </div>
</template>
<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import { getRpaConditionNodeDetail, getOperateList, getConditionLVList, updateRpaConditionNode } from "../service";
import ConditionGroup from "@/views/zhiji/components/commonForm/widgets/conditionGroup/index.vue";
import TextInput from "@/views/zhiji/components/commonForm/widgets/TextInput.vue";
import Validation from "@/views/zhiji/components/commonForm/validation.js";

import i18n from "@/i18n";

export default {
    name: "ConditionEditModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        RoundButton,
        ConditionGroup,
        TextInput
    },
    data() {
        return {
            typesOperators: [],
            params: [],
            elseGroupId: "",
            formModal: {
                // 条件组整体数据
                nodeName: "",
                groups: [],
                // else补充
                isSupply: false
            },
            // 校验规则
            rules: {
                nodeName: [
                    { required: true, message: "请输入节点名称", trigger: "blur" },
                    {
                        trigger: "blur",
                        validator(_, value, callback) {
                            if (/<|>/.test(value)) {
                                callback(new Error("名称不可携带<>,会有xss安全风险"));
                            } else {
                                callback();
                            }
                        }
                    }
                ]
            },
            groupNameWidget: {
                props: {
                    placeholder: "判断条件名称，如：当XXX时"
                }
            },
            groupNameRules: [{ required: true }],
            // 条件逻辑数据
            condWidgetConfig: {
                props: {
                    conditionParams: {
                        getParamConfig: () => {
                            return this.params;
                        },
                        getOptions: param => {
                            const typeConfig = this.typesOperators.find(item => param.valType == item.type);
                            return typeConfig.operators.map(item => ({
                                label: item.name,
                                value: item.op
                            }));
                        },
                        getValueType({ valType, options }) {
                            if (valType === "option") {
                                return {
                                    type: valType,
                                    props: {
                                        options
                                    }
                                };
                            }
                            return { type: valType };
                        }
                    }
                }
            },
            myValidation: null
        };
    },
    computed: {
        confirmLabel() {
            return this.$t("zhiji.common.confirm");
        },
        cancelLabel() {
            return this.$t("zhiji.common.cancel");
        },
        canSubmit() {
            return this.formModal.groups.filter(g => g.updateState != "delete").length > 0;
        }
    },
    async created() {
        this.myValidation = new Validation();
        this.typesOperators = await getOperateList();
        this.params = await getConditionLVList();
        await this.getNodeDetail(this.params);
    },
    destroyed() {
        this.myValidation && this.myValidation.destroy();
    },
    methods: {
        async getNodeDetail(params) {
            const { nodeName, isSupply, groups, elseGroupId } = await getRpaConditionNodeDetail(this.data, params);
            this.formModal.nodeName = nodeName;
            this.formModal.groups = groups ? groups : [{ updateState: "add", groupName: "", conditions: null }];
            this.formModal.isSupply = isSupply;
            this.elseGroupId = elseGroupId;
        },
        // 删除某个条件组
        deleteCondition(index) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.answer.deleteWidgetTip"),
                    confirm: () => {
                        const group = this.formModal.groups[index];
                        if (group.updateState === "add") {
                            this.formModal.groups.splice(index, 1);
                        } else {
                            group.updateState = "delete";
                        }
                    }
                }
            });
        },
        // 添加条件组
        addConditionGroup() {
            this.formModal.groups.push({ updateState: "add", groupName: "", conditions: null });
        },
        cancelClick() {
            this.close();
        },
        async confirmClick() {
            await this.validateForm(); // 校验表单是否成功
            await this.validateGroups();
            const data = {
                rpaId: this.data.rpaId,
                nodeId: this.data.nodeId,
                nodeType: this.data.nodeType,
                elseGroupId: this.elseGroupId,
                ...this.formModal
            };
            await updateRpaConditionNode(data);
            this.data.submit && this.data.submit();
            this.close();
        },
        groupNameChange(index) {
            this.groupChange(index);
        },
        groupChange(index) {
            const group = this.formModal.groups[index];
            if (group.updateState === "") {
                group.updateState = "update";
            }
        },
        close() {
            this.$emit("closeModal");
        },
        getIndex(index) {
            return String.fromCharCode("A".charCodeAt() + index);
        },
        async validateGroups() {
            const { isValid } = await this.myValidation.validate();
            if (!isValid) {
                throw Error("group校验失败");
            }
        },
        validateForm() {
            return new Promise((resolve, reject) => {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        resolve(true);
                    } else {
                        reject(valid);
                    }
                });
            });
        }
    }
};
</script>
<style scoped lang="less">
@import (reference) url("./common/rpaNode.less");
@contentWidth: 730px;
.add-condition-modal-wrapper {
    .modal-wrapper();
    /deep/ .title-base-mask {
        max-height: none;
        .base-content {
            padding: 0 10px 16px 0;
        }
    }
    .add-condition-box {
        width: 900px;
        max-height: 90%;
        .condition-title {
            width: @contentWidth;
        }
    }
    .condition-logic {
        display: flex;
        margin-top: 20px;
        .condition-logic-right {
            margin-left: 24px;
        }
    }
    .condition-logic-tip-title {
        display: flex;
        justify-content: space-between;
        width: @contentWidth;
        margin-bottom: 10px;
        margin-top: 3px;
        .use-guide {
            color: #2ec2ff;
            i {
                color: #2ec2ff;
            }
        }
    }
}
.add-condition-group-wrapper {
    .condition-group-btn {
        background: #fbfcfd;
        border: 1px solid #d8e4f0;
        border-radius: 4px;
        padding: 17px 16px;
        box-sizing: border-box;
        width: @contentWidth;
        .plus-btn {
            width: 28px;
            height: 28px;
            background: #2ec2ff;
            border-radius: 4px;
            padding: 5px 7px;
            margin-right: -5px;
            .el-icon-plus {
                color: #fff;
            }
        }
        &:hover {
            .supplement-cond {
                color: #2ec2ff;
            }
            &,
            .condition-index {
                background: #effbff;
                color: #2ec2ff;
                border: 1px solid #2ec2ff;
            }
        }
    }
    .condition-group-content {
        position: relative;
        box-sizing: border-box;
        background: #fbfcfd;
        border: 1px solid #d8e4f0;
        border-radius: 4px;
        padding: 20px 16px;
        margin-bottom: 8px;
        width: @contentWidth;
        .group-name {
            display: inline-block;
            color: #c8d8e5;
            .group-name-input {
                border-bottom: 1px solid #d8e4f0;
                width: 660px;
                padding-bottom: 6px;
                margin-left: 3px;
                margin-bottom: 23px;
            }
        }
    }
}
.group-name-error {
    /deep/ input {
        border-color: #ff384c !important;
    }
}
.condition-index {
    width: 16px;
    height: 16px;
    border-radius: 16px;
    border: 1px solid #c8d8e5;
    display: inline-block;
    background: #fff;
    line-height: 16px;
    text-align: center;
    color: #c8d8e5;
    font-size: 12px;
    font-weight: bold;
    margin-right: 3px;
    vertical-align: -1px;
}
.key-note {
    font-weight: bold;
    font-size: 16px;
    color: #3f4760;
}
.supplement-cond {
    font-size: 12px;
    color: #999999;
    margin-left: 18px;
}
.not-match-wrap {
    margin-top: 28px;
    .match-switch {
        margin-top: 10px;
        width: @contentWidth;
        background: #fbfcfd;
        border: 1px solid #d8e4f0;
        padding: 9px 16px;
        font-size: 14px;
        box-sizing: border-box;
        border-radius: 4px;
    }
}
.add-condition-bottom {
    .bottom-btn();
    padding-top: 16px;
    margin-top: 20px;
}
.add-condition-form-item {
    margin: 13px 0 20px 0;
}
.op {
    .span-op();
    position: absolute;
    right: -33px;
    top: -10px;
}
.delete {
    width: 16px;
    height: 18px;
    background: url(/zhiji/images/class-spr.png);
    background-position: -96px 0;
    &:hover {
        background-position: -96px -22px;
    }
}
.group-conditon {
    width: 640px;
}
.el-form-item__error {
    .form-item-error(42px, 40px);
}
.disabled-btn {
    background: #999999;
    &:hover {
        background: #999999;
    }
}
</style>
